<template>
  <div>
    <button class="btn-export-pdf" @click="exportPdf()">Export pdf</button>

    <div class="row" id="pdfDom">
      <section class="pdf-item">
        <div class="export-pdf-container cert-container cert-cover">
          <div class="content">
            <div class="box-certificate">
              <img
                class="certificate-logo"
                :src="'img/imgPdf/logo-upm.png'"
                alt=""
              />
              <p class="cert-uni-name">{{ universityInfo.name }}</p>
              <!--        <p class="cert-uni-nation">{{ universityInfo.nation }}</p>-->
              <p class="cert-uni-nation">{{ universityInfo.nation }}</p>
              <img
                :src="
                  `img/icon-certificate/${getStarImg(
                    universityInfo.university_type_id === 1
                      ? 'research'
                      : 'applied',
                    uniSummaryRating.star,
                    uniSummaryRating.extra
                  )}`
                "
                alt=""
                class="research-plus"
              />

              <!--        <p class="cert-year">{{ new Date().getFullYear() }}</p>-->
              <p class="cert-uni-type">
                {{
                  universityInfo.university_type
                    ? universityInfo.university_type.name
                    : ""
                }}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { UniversityService } from "../../../services/university.service";
import { NationService } from "../../../services/nation.service";
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import { mapMutations } from "vuex";

export default {
  name: "ExportPdfIndex",
  components: {},

  data() {
    return {
      universityInfo: {},
      uniSummaryRating: {},
      uniCategoryRatings: [],
      htmlToPdfOptions: {
        margin: 0,

        filename: `certificate.pdf`,

        enableLinks: false,

        html2canvas: {
          scale: 1,
          useCORS: true
        },

        jsPDF: {
          unit: "px",
          format: "a4",
          orientation: "portrait"
        }
      }
    };
  },
  created() {
    this.getDetailUniversity();
    this.getUniversitySummaryRating();
    // this.getUniversityCategoryRating();
  },
  methods: {
    ...mapMutations({
      hideLoading: "HIDE_LOADING",
      showLoading: "SHOW_LOADING"
    }),
    async exportPdf() {
      this.showLoading();
      setTimeout(async () => {
        let pages = document.getElementsByClassName("pdf-item");
        await this.exportHTMLToPDF(pages)
          .then(() => {})
          .finally(() => {
            this.hideLoading();
          });
      }, 5000);
    },
    async exportHTMLToPDF(pages) {
      console.log("exportHTMLToPDF pages", pages);
      const opt = {
        margin: [0, 0],
        filename: "myfile.pdf",
        pagebreak: { mode: ["css", "legacy"], before: ".page-break-pdf" },
        image: { type: "jpeg", quality: 1 },
        html2canvas: {
          dpi: 192,
          scale: 4,
          letterRendering: true,
          useCORS: true
        },
        jsPDF: { unit: "pt", format: "a4", orientation: "landscape" }
      };
      const doc = new jsPDF(opt.jsPDF);
      const pageSize = jsPDF.getPageSize(opt.jsPDF);
      for (let i = 0; i < pages.length; i++) {
        const page = pages[i];
        let contentWidth = (595 * 4) / 3;
        let contentHeight = page.clientHeight;
        let pageHeight = (contentWidth / 592.28) * 841.89;
        // page offset
        let position = 0;
        let leftHeight = contentHeight;
        if (i != 0) {
          doc.addPage();
        }

        // L: Landscape, p: portrait; unit: in: inches, mm mm; canvas size: A3, A4, Leeter, [] (when the content is array, for custom size)
        const pageImage = await html2pdf()
          .from(page)
          .set(opt)
          .outputImg();
        if (leftHeight <= pageHeight) {
          doc.addImage(
            pageImage.src,
            "jpeg",
            opt.margin[0],
            opt.margin[1],
            pageSize.width,
            pageSize.height
          );
        } else {
          while (leftHeight > 0) {
            doc.addImage(pageImage.src, "jpeg", 0, position);

            leftHeight -= pageHeight;
            position -= 841.89;
            if (leftHeight > 0) {
              doc.addPage();
            }
          }
        }
      }
      doc.save("university_cover.pdf", { returnPromise: true });
    },
    // downloadPDF() {
    //   this.$refs.html2Pdf.generatePdf();
    // },
    async getDetailUniversity() {
      let uniInfo = await new UniversityService().getById(
        this.$route.params.id
      );
      let nation = await this.getNation(uniInfo.country_alpha_two_code);
      this.universityInfo = { ...uniInfo, nation: nation };
    },
    async getUniversityCategoryRating() {
      const response = await new UniversityService().getRatetingByUniId(
        this.$route.params.id
      );
      if (!response) {
        return;
      }

      response.forEach(category => {
        category.star = category.star || null;
        category.weight = category.weight || 0;
        category.score = category.score || 0;
        category.extra = category.extra || "";
      });
      this.uniCategoryRatings = response;
    },
    async getNation(country_alpha_two_code) {
      const nation = new NationService().getNation(country_alpha_two_code);
      if (!nation) {
        return;
      }
      return nation.data.name;
    },
    async getUniversitySummaryRating() {
      const response = await new UniversityService().getUniversityRatingSummaries(
        this.$route.params.id
      );
      if (!response) {
        return;
      }
      let uniSummary = {
        weight: response.weight || 0,
        score: response.score || 0,
        star: response.star || 0,
        extra: response.extra || ""
      };
      this.uniSummaryRating = uniSummary;
    },
    getStarImg(divisionName, star = "", extra = "") {
      const displayStar =
        star && star >= 1 ? Math.floor(star / 1).toFixed(0) : 1;
      return `${divisionName}_${_.toLower(extra)}${displayStar}.png`;
    },
    getCategoryStarImg(divisionName, star = "") {
      const displayStar = star && star >= 1 ? parseInt(star) : 1;
      return `${divisionName}_${displayStar}.svg`;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../assets/scss/pdf.scss";
</style>
